import { Field } from 'module/api/field/types';
import { useCallback, useState } from 'react';

interface FieldDrawerState {
  visible: boolean;
  field?: Field;
}
interface ReturnProps {
  drawerState: FieldDrawerState;
  openDrawerInCreateMode: VoidFunction;
  openDrawerInEditMode: (field: Field) => void;
  closeDrawer: VoidFunction;
}
export const useManageFieldDrawerState = (): ReturnProps => {
  const [drawerState, setDrawerState] = useState<FieldDrawerState>({
    visible: false,
  });
  const closeDrawer = useCallback(() => {
    setDrawerState({ visible: false });
  }, []);
  const openDrawerInCreateMode = useCallback(() => {
    setDrawerState({ visible: true });
  }, []);
  const openDrawerInEditMode = useCallback((field: Field) => {
    setDrawerState({ visible: true, field });
  }, []);

  return {
    drawerState,
    openDrawerInCreateMode,
    openDrawerInEditMode,
    closeDrawer,
  };
};
